export default (name) => (typeof window !== 'undefined' ? JSON.parse(localStorage.getItem(`ehomuteboards-${name}`, {})) : {});
